var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHardcoregamer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -1 59 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.4,21.7v-6.8c0-1.1,1-1.2,1-1.2h0.2v-1.5L23,11.8l0,0v9.8h-1.6L20,20.7l-1.5,0.9h-1.6V11.2l-5.5-0.4 l-0.7,1.3l0.2,0.1c1.1,0.6,1.2,2,1.2,2v7.5L11,23.4l1.1,1.7v7.4c0,1.9-1.1,2.4-1.2,2.5l-0.2,0.1l0.8,1.3L17,36V25.2h1.6l1.4,0.9 l1.4-0.9H23v10.1l5.6-0.4v-1.5h-0.1c0,0-0.9-0.3-0.9-1.3v-7l1.1-1.7L27.4,21.7L27.4,21.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.8,34.8c0,0-1.2-0.5-1.2-2.5v-7.2l1.2-1.7l-1.2-1.8l-7.8-0.1v3.7h3V32l-6.2-0.4V15.1l6.1-0.4v3.6h4.9v-4.1 c0,0-0.1-1.4,1.2-2l0.2-0.1l-0.8-1.4l-17.1,1.4v1.5h0.1c0,0,0.9,0.1,0.9,1.2v6.9L31,23.4l1.2,1.7v7c0,1.1-1,1.3-1.1,1.3H31v1.6 l17.1,1.3l0.8-1.4L48.8,34.8L48.8,34.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.8,20V5.9l-1.2-0.2C54,5.6,42.1,3.1,33.5,2.4l-4-2.7l-4,2.7C16,3,5,5.6,4.5,5.7L3.4,6V20l-2.6,3.8l2.6,3.8 v13.7l1.1,0.3c0.5,0.2,11.7,3.3,21.4,4l3.9,2.7l4-2.8c8.7-0.9,20.3-3.8,20.9-3.9l1.1-0.3V27.8l2.7-3.9C58.5,23.8,55.8,20,55.8,20z M52.8,27.5V39C49.6,39.8,40,42,33,42.6l-3.4,2.3l-3.3-2.3C18.6,42,9.5,39.8,6.4,39V27.2l-2.3-3.4l2.3-3.4V8.4 c3.1-0.7,12.1-2.6,19.8-3.1l3.5-2.4l3.5,2.4c7,0.5,16.4,2.4,19.7,3v12.1l2.4,3.5L52.8,27.5L52.8,27.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardcoregamer);
export default __webpack_public_path__ + "static/media/hardcoregamer.1b7856cdc1ce728742e690ed71c2204f.svg";
export { ForwardRef as ReactComponent };